// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Taetigkeitsbericht } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetTaetigkeitsbericht(): (
  taetigkeitsberichtId: string
) => Promise<Taetigkeitsbericht> {
  const getAPI = useGetApi();
  return useCallback(
    async (taetigkeitsberichtId) =>
      (await getAPI()).taetigkeitsberichte.getTaetigkeitsbericht({
        taetigkeitsberichtId,
      }),
    [getAPI]
  );
}
